import { teamMember } from '@/api/common.js';

// 获取身份信息
async function getTeamMember() {
  const res = await teamMember();

  return res;
}

// 文件上传格式
const uploadFileList = ['pdf', 'dwg', 'png', 'jpg', 'jpeg', 'webp'];

// 文件上传格式
const imageFileList = ['png', 'jpg', 'jpeg', 'webp'];

// 防抖
function debounce(fn, wait) {
  let timer = false;
  return function () {
    clearTimeout(timer);
    timer && clearTimeout(timer);
    timer = setTimeout(() => {
      timer = false;
      fn.apply(this, arguments); // 把参数传进去
    }, wait);
  };
}

// 高亮文字
function highlightWord(text, keyword) {
  //i代表忽略大小写，g代表全局匹配，不加g可以理解为str.replace('Ab')，加g为replaceAll('Ab')，此处'Ab'不区分大小写（正则不能放在replaceAll中）
  const oRegExp = new RegExp('(' + keyword + ')', 'ig');
  //$1代表正则中第一个小括号"()"本次的匹配结果,$2为第二个，以此类推；
  return text.replace(oRegExp, `<span class="color-theme">$1</span>`);
}

// 数字千分位转化
function thousandFormat(number) {
  // 数字转为字符串，并按照 .分割
  let arr = (number + '').split('.');
  let int = arr[0] + '';
  let fraction = arr[1] || '';
  // 多余的位数
  let f = int.length % 3;
  // 获取多余的位数，f可能是0， 即r可能是空字符串
  let r = int.substring(0, f);
  // 每三位添加','金额对应的字符
  for (let i = 0; i < Math.floor(int.length / 3); i++) {
    r += ',' + int.substring(f + i * 3, f + (i + 1) * 3);
  }
  // 多余的位数，上面
  if (f === 0) {
    r = r.substring(1);
  }
  // 调整部分和小数部分拼接
  return r + (!!fraction ? '.' + fraction : '');
}

// 是否空对象
function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
}

// 场景icon map
function formatScene(tag) {
  const map = {
    Home: 'ic_home_nor',
    Enterprise: 'ic_prof_office',
    Hotel: 'ic_prof_hotel',
    Business: 'ic_scenes_store',
    School: 'ic_scenes_educate',
    ScenicSpot: 'ic_scenes_scenicspot',
    Hospital: 'ic_scenes_hospital',
    Plaza: 'ic_scenes_complex',
    Factory: 'ic_scenes_workshop',
    KTV: 'ic_scenes_KTV',
    Monitor: 'ic_device_camera',
    Estate: 'ic_prof_community',
    General: 'ic_network'
  };
  return map[tag];
}

export {
  getTeamMember,
  uploadFileList,
  imageFileList,
  debounce,
  highlightWord,
  thousandFormat,
  isEmptyObject,
  formatScene
};
